export type AllowedViewMode = 'digital' | 'print';

export function isAllowedViewMode(type: string): type is AllowedViewMode {
  return type === 'digital' || type === 'print';
}
